var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSoundCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "64px",
    height: "64px",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#000000;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} .st1{fill:none;stroke:#000000;stroke-width:2;} .st2{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M26,14c-0.8,0-1.5,0.2-2.1,0.5C23.2,10.8,20,8,17,8c-0.3,0-0.7,0-1,0.1V24h1h2h7c2.8,0,5-2.2,5-5S28.8,14,26,14 z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 13,
    y1: 10,
    x2: 13,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 10,
    y1: 16,
    x2: 10,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 7,
    y1: 13,
    x2: 7,
    y2: 24
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 4,
    y1: 17,
    x2: 4,
    y2: 23
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 1,
    y1: 18,
    x2: 1,
    y2: 22
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoundCloud);
export default __webpack_public_path__ + "static/media/sound-cloud.0b95208b4730fb9a25bea229172a7fd6.svg";
export { ForwardRef as ReactComponent };